<template lang="pug">
span.field-hint(@mouseover="hintMouseover($event)", @mouseleave="hintMouseleave()")
  q-icon.hint-icon(name="help")
  p.hint-text(:style="hintStyles") {{ text }}
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

const props = defineProps({
  text: { type: String, default: "", required: true },
});

const emit = defineEmits(["change", "reset"]);

const showText = ref(false);
const hintPositionX = ref(0);
const hintPositionY = ref(0);
const hintTranslateX = ref(0);

const text = computed(() => props.text);
const hintStyles = computed(() => {
  return {
    visibility: `${showText.value ? "visible" : "hidden"}`,
    left: `${hintPositionX.value}px`,
    top: `${hintPositionY.value}px`,
    "--translateX": hintTranslateX.value,
  };
});

const hintMouseover = e => {
  const hintEl = e.currentTarget.querySelector(".hint-icon");
  const hintRect = hintEl.getBoundingClientRect();

  const deviationArrowHeight = 10;

  hintPositionX.value = hintRect.left + hintRect.width / 2;
  hintPositionY.value = hintRect.top + hintRect.height / 2 + deviationArrowHeight;

  const hintTextEl = e.currentTarget.querySelector(".hint-text");
  const hintTextWidth = hintTextEl.getBoundingClientRect().width;

  const rightOverflow = hintPositionX.value + hintTextWidth / 2 - window.innerWidth;

  if (rightOverflow > 0) {
    hintTranslateX.value = `${rightOverflow}px`;
  } else {
    hintTranslateX.value = "0px";
  }

  showText.value = true;
};

const hintMouseleave = () => {
  hintPositionX.value = 0;
  hintPositionY.value = 0;
  hintTranslateX.value = 0;

  showText.value = false;
};
</script>

<style lang="scss">
.field-hint {
  cursor: pointer;
}

.hint-text {
  position: fixed;
  width: 400px;
  text-align: center;
  background-color: #343442;
  color: #e8e8e8;
  z-index: 1;
  box-shadow: 0 1px 2px rgba(89, 89, 89, 0.16), 0 2px 4px rgba(0, 0, 0, 0.08), 0 1px 8px rgba(73, 73, 73, 0.1);
  border-radius: 5px;
  padding: 2px 8px;
  margin-top: 5px;
  transform: translateX(calc(-50% - var(--translateX, 0px)));

  &::before {
    content: "";
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #343442;
    left: 50%;
    transform: translateX(calc(-50% + var(--translateX, 0px)));
    top: -8px;
    position: absolute;
  }
}
</style>
